module.exports = __webpack_public_path__ + "img/batch.88e0d30c.svg";